import { Suspense, type PropsWithChildren } from 'react'

import { PageLayoutSkeleton } from '@/layouts/page'

import { ConfiguracoesParametrosSkeleton } from './configuracoes-parametros.skeleton'

export const ConfiguracoesParametrosPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <ConfiguracoesParametrosSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}
